import * as Yup from "yup";
import {
  DOC_STATUS_APPROVED,
  REJECTED_FROM_CITIZEN,
  TEMPORARILY_SAVED,
} from "../../../../constants";

function validateDocuments(uploadedDocuments, docsPerKind, status) {
  if (status === TEMPORARILY_SAVED || status === REJECTED_FROM_CITIZEN) {
    return true;
  } else {
    const requiredDocumentsIds = docsPerKind
      ?.filter((doc) => doc.req_flg)
      ?.map((doc) => doc.doc_id);

    const uploadedDocumentsIds = uploadedDocuments?.map(
      (uploadedDoc) => uploadedDoc.id
    );

    const uploadedDocumentsDocIds = uploadedDocuments?.map(
      (uploadedDoc) => uploadedDoc.doc_id
    );

    // console.log("areAllDocumentsUploaded");
    // console.log(requiredDocumentsIds);
    if (requiredDocumentsIds === undefined) {
      return null;
    }
    if (requiredDocumentsIds !== null && requiredDocumentsIds !== undefined && requiredDocumentsIds.every !== undefined) {
      const areAllDocumentsUploaded = requiredDocumentsIds.every(
        (requiredDocId) => {
          if (uploadedDocumentsIds !== undefined && uploadedDocumentsDocIds !== undefined) {
            // console.log("uploadedDocumentsIds");
            // console.log(uploadedDocumentsIds);
            if (
              !uploadedDocumentsIds.includes(requiredDocId) &&
              !uploadedDocumentsDocIds.includes(requiredDocId)
            ) {
              // // console.log("missing: ", requiredDocId);
            }
            // Ther reason we're checking for both ids and docIds
            // is that in the case of temporary save,
            // the uploaded documents are recognized by ids.
            // However, if user has already uploaded some documents
            // previously while also being in temporary save,
            // we need to check doc_ids
            return (
              uploadedDocumentsIds.includes(requiredDocId) ||
              uploadedDocumentsDocIds.includes(requiredDocId)
            );
          }
        }
      );
      return areAllDocumentsUploaded;
    } else {
      return null;
    }



  }
}

const checkRejectedDocuments = (uploadedDocuments) => {
  // Check if there are rejected documents and return false if there are
  // so that formik fails validation and generates error message

  return uploadedDocuments?.every((doc) => doc.sts_flg !== 2);
  // const documentsAreValidated = uploadedDocuments?.every((doc) => {
  //   if (doc.new) {
  //     return true;
  //   }
  //   return doc.sts_flg === DOC_STATUS_APPROVED;
  // });

  // return documentsAreValidated;
};

const getValidationForMe = (t, docsPerKind) => {
  return Yup.object().shape({
    // portAuthority: Yup.object().required(t("Field is required")),
    appl_kind_id: Yup.number().required(t("Field is required")),
    email_afora: Yup.string()
      .email(t("Invalid email"))
      .required(t("Field is required")),
    ind_nr_afora: Yup.string().required(t("Field is required")),
    status: Yup.number().required(t("Field is required")),
    dt_birth_afora: Yup.date().required(t("Field is required")),
    uploadedDocuments: Yup.array()
    .when('$uploadedDocuments', (uploadedDocuments, schema) =>
      uploadedDocuments === undefined ? schema : schema
      .test(
        "documents-rejected",
        t("There are documents that have been rejected by the service") +
        ". " +
        t("Please upload new ones"),
        () => checkRejectedDocuments(uploadedDocuments)
      )
      .test(
        "includes-required",
        t("Required documents missing"),
        function (uploadedDocuments) {
          return validateDocuments(uploadedDocuments, docsPerKind, this.parent.status);
        }
      ),),
    amka_afora: Yup.string()
      .required(t("Field is required"))
      .nullable()
      .min(11, t("Field must be 11 digits"))
      .max(11, t("Field must be 11 digits")),
    tel_afora: Yup.string()
      .required(t("Field is required"))
      .nullable()
      .min(10, t("Phone number must be 10 digits"))
      .max(10, t("Phone number must be 10 digits")),
    mobile_afora: Yup.string()
      .required(t("Field is required"))
      .nullable()
      .min(10, t("Mobile number must be 10 digits"))
      .max(10, t("Mobile number must be 10 digits")),
    tk_afora: Yup.number()
      .typeError(t("Field must be only numbers"))
      .test(
        "len",
        t("Postal code must be 5 digits"),
        (val) => parseInt(val).toString().length === 5
      ),
  });
};
export default getValidationForMe;
